import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface LabVariantState {
  variantKeys: Record<string, string | null>
  setVariantKey: (patientId: string, variantKey: string | null) => void
}

/**
 * The chosen context describes the patient, not the result, so it follows them from biomarker to
 * biomarker — but a guardian switching between household members must not inherit anyone else's.
 */
export const useLabVariantStore = create<LabVariantState>()(
  persist(
    (set) => ({
      variantKeys: {},
      setVariantKey: (patientId, variantKey) =>
        set((state) => ({ variantKeys: { ...state.variantKeys, [patientId]: variantKey } })),
    }),
    {
      name: 'lab-variant-storage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
